import React, { memo, useEffect, useRef, useState } from 'react';
import { CustomPromotionVoucher, PromotionVoucher } from 'types/Product';
import styled from 'styled-components';
import PromotionVoucherCard from './Card/PromotionVoucherCard';
import PercentageAndDeliveryVoucherDialog from './Dialog/PercentageAndDeliveryVoucherDialog';

export interface PromotionVoucherContainerProps {
  promotionVoucher: PromotionVoucher | CustomPromotionVoucher;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const isPromotionVoucher = (voucher: any): voucher is PromotionVoucher =>
  voucher && typeof voucher.type === 'string' && typeof voucher.voucherCode === 'string';

const PercentageAndDeliveryVoucher = memo((props: PromotionVoucherContainerProps) => {
  const { promotionVoucher } = props;

  if (!isPromotionVoucher(promotionVoucher)) {
    return null; // or handle the case where promotionVoucher is not of type PromotionVoucher
  }

  const { offerTerms, offerTerms2, offerTerms3 } = promotionVoucher;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogRendered, setDialogRendered] = useState(false);
  const isFirstRender = useRef(true);
  const modalOfferTerms = offerTerms.concat(' ', offerTerms2 || '', ' ', offerTerms3 || '').trimEnd();

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (dialogRendered) {
      setDialogOpen(true);
    }
  }, [dialogRendered]);

  const openDialog = () => {
    if (dialogRendered) {
      setDialogOpen(true);
    } else {
      setDialogRendered(true);
    }
  };

  const closeDialog = () => setDialogOpen(false);

  return (
    <Container>
      <PromotionVoucherCard promotionVoucher={promotionVoucher} openDialog={openDialog} />
      {dialogRendered && (
        <PercentageAndDeliveryVoucherDialog
          promotionVoucher={promotionVoucher}
          dialogOpen={dialogOpen}
          closeDialog={closeDialog}
          modalOfferTerms={modalOfferTerms}
        />
      )}
    </Container>
  );
});

export default PercentageAndDeliveryVoucher;
